import { CannabisIcon } from "@/components/icons/CannabisIcon";
import { currentFeatures } from "@/configs/Settings";
import { useSessionContext } from "@/contexts/SessionContext";
import { IFeatures } from "@/utils/interfaces";

import { PatientSupportingDocumentsPage } from "./PatientSupportingDocumentsPage";

/** Rota dedicada — acessível pelo atalho no dashboard do paciente. */
export function usePatientSupportingDocumentsPage() {
  const { access } = useSessionContext();

  const configs: IFeatures = {
    active: access?.type === "patient" && currentFeatures.defaultApp,
    path: "/patient-documents",
    icon: CannabisIcon,
    text: "Tratamento canabinoide",
    component: () => <PatientSupportingDocumentsPage />,
  };

  return configs;
}
